// extracted by mini-css-extract-plugin
export default {"wrapper":"FullMenu_wrapper__eA092","container":"FullMenu_container__o+LwA","title":"FullMenu_title__WgUlk","list":"FullMenu_list__s5gv7","listItem":"FullMenu_listItem__v69bM"};